/*
 *  -----------------------------------------------------------------------
 *    <copyright file="text-field.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import { TextFieldProps } from '@mui/material';
import MuiTextField from '@mui/material/TextField';

interface IWithDataTestId {
    'data-testid'?: string;
}

type ExtendedTextFieldProps = TextFieldProps & IWithDataTestId;

const TextField = (props: ExtendedTextFieldProps) => {
    const { id, 'data-testid': dataTestId, slotProps } = props;

    const customProps: IWithDataTestId = {};

    if (id && !dataTestId) {
        customProps['data-testid'] = id;
    }

    return (
        <MuiTextField
            slotProps={{ ...slotProps, inputLabel: { ...slotProps?.inputLabel, shrink: true } }}
            {...props}
            {...customProps}
        />
    );
};
export default TextField;
